function injectData(cartData) {
  const variantIdFor1500 = 37002480779421;
  const variantIdFor2000 = 37002490642589;
  const variantIdFor2500 = 37002502930589;
  const variantIdForMan1500 = 39462962528413;
  const items = cartData.items;
  const variantIdsAlongWithDataToBeAdded = {};
  variantIdsAlongWithDataToBeAdded[variantIdFor1500] = 0;
  variantIdsAlongWithDataToBeAdded[variantIdFor2000] = 0;
  variantIdsAlongWithDataToBeAdded[variantIdFor2500] = 0;
  variantIdsAlongWithDataToBeAdded[variantIdForMan1500] = 0;
  items.forEach((singleCartItem) => {
    let additionalPrice = 0;
    if (singleCartItem && singleCartItem.properties) {
      additionalPrice = +singleCartItem.properties['__price'];
      if (isNaN(additionalPrice)) {
        additionalPrice = 0;
      }
    }

    if (additionalPrice) {
      const currentQuantity = singleCartItem.quantity;

      let variantIdToBeAdded = '';
      if (additionalPrice === 11.69) {
        variantIdToBeAdded = variantIdFor1500;
      } else if (additionalPrice === 15.59) {
        variantIdToBeAdded = variantIdFor2000;
      } else if (additionalPrice === 18.84) {
        variantIdToBeAdded = variantIdFor2500;
      }
      else if (additionalPrice === 11.04) {
        variantIdToBeAdded = variantIdForMan1500;
      }
      if (variantIdToBeAdded) {
        const currentData =
          variantIdsAlongWithDataToBeAdded[variantIdToBeAdded];
        if (currentData) {
          variantIdsAlongWithDataToBeAdded[
            variantIdToBeAdded
          ] += currentQuantity;
        } else {
          variantIdsAlongWithDataToBeAdded[
            variantIdToBeAdded
          ] = currentQuantity;
        }

        // let formData = {
        //   'items': [{
        //   'id': 36110175633573,
        //   'quantity': 2
        //   }]
        // };
      }
    }
  });

  if (Object.keys(variantIdsAlongWithDataToBeAdded).length === 0) {
    redirectToCheckout();
  } else {
    updateItemInCartCustom(variantIdsAlongWithDataToBeAdded);
  }
}

function redirectToCheckout() {
  window.location.href = '/checkout';
}

function updateItemInCartCustom(cartNewJson) {
  var e = {
    type: 'POST',
    url: '/cart/update.js',
    data: {
      updates: cartNewJson,
    },
    dataType: 'json',
    success: function () {
      console.log('data successfully added to cart with extra prices');
      redirectToCheckout();
    },
    error: function (t, r) {
      console.log('data failed to be added to cart with extra prices', t, r);
      redirectToCheckout();
    },
  };
  jQuery.ajax(e);
}

function changeCartItemAttributes(updateJSON) {
  return new Promise(function (resolve) {
    const e = {
      type: 'POST',
      url: '/cart/change.js',
      data: updateJSON,
      dataType: 'json',
      success: function () {
        resolve();
      },
      error: function (t, r) {
        resolve();
      },
    };
    jQuery.ajax(e);
  });
}

async function updateAllLineItemProperties(currentCartData) {
  try {
    const items = currentCartData.items;
    const itemsToUpdate = items
      .map((singleCartItem, index) => {
        const optionWithValues = singleCartItem.options_with_values;
        if (optionWithValues && optionWithValues.length > 0) {
          let currentProperty = singleCartItem.properties;
          currentProperty = currentProperty ? currentProperty : {};
          const currentFinalProperties = {};
          Object.entries(currentProperty).forEach(([K, V]) => {
            if (K && V) {
              currentFinalProperties[K.toLowerCase()] = V;
            }
          });
          const optionWithValuesToObject = {};
          let anyItemsFoundInOptionWithValues = false;
          optionWithValues.forEach((singleItem) => {
            if (singleItem.name && singleItem.value) {
              //ignoring skus which are having only one variants
              //and are no more required
              if (singleItem.value.toLowerCase() !== 'default title') {
                anyItemsFoundInOptionWithValues = true;
                optionWithValuesToObject[singleItem.name.toLowerCase()] =
                  singleItem.value;
              }
            }
          });

          const finalProperties = {
            ...currentProperty,
            ...optionWithValuesToObject,
          };
          if (!finalProperties['size']) {
            anyItemsFoundInOptionWithValues = true;
            finalProperties['size'] = 'none';
          }
          if (!finalProperties['color']) {
            anyItemsFoundInOptionWithValues = true;
            finalProperties['color'] = 'none';
          }
          if (!anyItemsFoundInOptionWithValues) {
            return null;
          }
          return {
            line: index + 1,
            quantity: singleCartItem.quantity,
            properties: finalProperties,
          };
        }
        return null;
      })
      .filter((item) => item !== null);

    console.log('items to update are: ', itemsToUpdate);
    if (itemsToUpdate.length === 0) {
      //no line items to update for now
      injectData(currentCartData);
      return;
    }

    //there are some valid cart items found to be updated
    for (const singleItem of itemsToUpdate) {
      await changeCartItemAttributes(singleItem);
    }
    //start injecting cart data now
    injectData(currentCartData);
  } catch (err) {
    injectData(currentCartData);
  }
}

function addAdditionalItemsToCart() {
  console.log('On cart additional information called');
  $.getJSON('/cart.js', function (t) {
    const cartData = t;
    console.log('Cart data is: ', cartData);
    updateAllLineItemProperties(cartData);
  });
}
